import { confirmSalesHeaders, getConfigVoucher } from 'actions'
import withMenu from 'components/common/withMenu'
import GlobalContainer from 'components/layout/globalContainer'
import SalesMonitorComponent from 'components/SalesMonitor/SalesMonitorComponent'
import { P_SALES_MONITOR } from 'constants/ConfigProcessNames'
import React, { Component } from 'react'
import { Row } from 'react-bootstrap'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { ISalesMonitorProps } from './SalesMonitorType'

export class SalesMonitor extends Component<ISalesMonitorProps> {
	myRef: any = React.createRef()

	getShortcuts = () => {
		const shortcuts = [
			{
				hotkey: { charCode: 'F5', modifiers: ['f5'] },
				action: this.toggleFilters,
				name: 'Change input search',
				description: 'Change input search'
			}
		]

		return shortcuts
	}

	toggleFilters = () => {
		this.myRef.toggleFilters()
	}

	/**
	 * redirect next page
	 * @param url
	 */
	handleConfirmationForm = (url: string) => {
		this.props.history.push(url)
	}

	handleCallBackButton = () => {
		this.myRef.handleConfirmForm()
	}

	render() {
		const containerProps = {
			codeProcess: P_SALES_MONITOR,
			shortcuts: this.getShortcuts(),
			callBackButton: this.handleCallBackButton,
			nextPage: true
		}

		const componentProps = {
			componentRef: (ref: any) => (this.myRef = ref)
		}

		return (
			<Row>
				<GlobalContainer {...containerProps}>
					<SalesMonitorComponent {...componentProps} />
				</GlobalContainer>
			</Row>
		)
	}
}

const mapStateToProps = ({ auth }: any) => ({})

const mapDispatchToProps = {
	confirmSalesHeaders,
	getConfigVoucher
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withRouter(withMenu(SalesMonitor)))
